import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";

const FEATURES = ["Graft Count", "Density Map", "PDF Report", "Video Mode"];

const NewAnalysisCard = () => {
  const navigate = useNavigate();

  return (
    <div
      className="relative w-full rounded-2xl overflow-hidden"
      style={{
        background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.09)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        boxShadow: "0 24px 48px rgba(0,0,0,0.35)",
      }}
    >
      {/* Top accent line */}
      <div
        className="absolute top-0 left-0 right-0 h-[1px]"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, #3B82F6 35%, #06B6D4 65%, transparent 100%)",
        }}
      />

      {/* Inner glow */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: "-60px",
          left: "10%",
          width: "300px",
          height: "200px",
          background:
            "radial-gradient(circle, rgba(59,130,246,0.14) 0%, transparent 70%)",
          filter: "blur(16px)",
        }}
      />

      <div className="relative flex flex-col md:flex-row items-center gap-8 p-8 md:p-10">

        {/* Left: Icon + Info */}
        <div className="flex items-start gap-6 flex-1 min-w-0">
          {/* Icon */}
          <div
            className="flex-shrink-0 w-16 h-16 rounded-2xl flex items-center justify-center"
            style={{
              background:
                "linear-gradient(135deg, rgba(59,130,246,0.22), rgba(6,182,212,0.14))",
              border: "1px solid rgba(59,130,246,0.32)",
              boxShadow: "0 0 28px rgba(59,130,246,0.2)",
            }}
          >
            <Icon name="ScanLine" size={28} color="#60A5FA" />
          </div>

          {/* Text */}
          <div className="flex-1 min-w-0">
            <span
              className="inline-flex items-center text-[10px] font-semibold tracking-[0.15em] uppercase px-2 py-0.5 rounded mb-3"
              style={{
                background: "rgba(59,130,246,0.15)",
                color: "#93C5FD",
                border: "1px solid rgba(59,130,246,0.25)",
              }}
            >
              AI-Powered Analysis
            </span>

            <h3
              className="text-2xl font-light tracking-tight mb-2"
              style={{ color: "#F1F5F9" }}
            >
              Start New Analysis
            </h3>

            <p className="text-sm leading-relaxed mb-5" style={{ color: "#94A3B8" }}>
              Upload patient scalp images and receive accurate AI-powered graft
              counts, density mapping, and clinical reports — instantly.
            </p>

            {/* Feature tags */}
            <div className="flex items-center gap-4 flex-wrap">
              {FEATURES.map((tag) => (
                <span
                  key={tag}
                  className="flex items-center gap-1.5 text-xs"
                  style={{ color: "rgba(255,255,255,0.35)" }}
                >
                  <span
                    className="w-1 h-1 rounded-full flex-shrink-0"
                    style={{ background: "#22D3EE", opacity: 0.7 }}
                  />
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Right: CTA */}
        <div className="flex-shrink-0 flex flex-col items-center gap-2">
          <button
            onClick={() => navigate("/new-analysis")}
            className="group flex items-center gap-3 px-8 py-4 rounded-xl font-medium text-white transition-all duration-200"
            style={{
              background: "linear-gradient(135deg, #1D4ED8, #0EA5E9)",
              boxShadow: "0 8px 24px rgba(29,78,216,0.45)",
              fontSize: "0.9rem",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = "0 10px 36px rgba(29,78,216,0.65)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = "0 8px 24px rgba(29,78,216,0.45)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <Icon name="Zap" size={17} color="white" />
            Begin Analysis
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="group-hover:translate-x-1 transition-transform duration-200"
              style={{ color: "rgba(255,255,255,0.65)" }}
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
          <p className="text-[11px]" style={{ color: "rgba(255,255,255,0.2)" }}>
            JPG · PNG · Max 10MB
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewAnalysisCard;
